export default __webpack_public_path__ + "media/zurb/img/lab/playground/responsive-email-templates/newsletter-f329a2cb3bd1c779613efe5db7fe5f22.jpg";